import React, { ReactElement } from 'react';
import SignUpPage from 'components/login/SignUpPage';
import { ServerSideInitProps } from 'types/types';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page = (): ReactElement => <SignUpPage />;

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    const props = await getPageProps<Props>({
        givenProps: {},
        res,
        req,
        api,
        query,
        loadUserData: true,
        translatePage: true,
        nameSpaces: getPageNamespaces('/signup'),
    });

    return {
        props,
    };
};

export default Page;
